module.exports = __webpack_public_path__ + "static/media/icn-hamburger-menu.80a45da9.svg";